@import (reference) '../../../../constants/spacing.module.less';

.drawer-level-two {
  inset: 115px 0 0;
}

.drawer-header {
  margin: 0;
  min-height: 40px;
  padding: 0;
  font-size: 1rem;
  line-height: 40px;
  font-weight: 500;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  background-color: var(--gray-F7F7F8);
  padding: @space-24 @space-24;
}

.drawer-footer {
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-shrink: 0;
  padding: @space-16 @space-24;
  z-index: 1002; // Temporary workaround for footer being behind the drawer content
}

.marketplace-icon {
  height: 24px;
  width: 40px;
  object-fit: contain;
}
